import { type ReactNode, useState } from 'react'

import type { ChangeFilterOptions } from '~/hooks/services/servicenow/queries/useChangesQuery'

import { DEFAULT_FILTER_OPTIONS } from '../../constants'
import { ChangeScheduleFiltersContext } from './context'

export function ChangeFiltersProvider({ children }: { children: ReactNode }) {
  const [filterOptions, setFilterOptions] = useState<ChangeFilterOptions>(DEFAULT_FILTER_OPTIONS)

  return <ChangeScheduleFiltersContext.Provider value={{ filterOptions, setFilterOptions }}>{children}</ChangeScheduleFiltersContext.Provider>
}
